import { styled } from 'styles/stitches.config'

export const Left = styled('article', {
  flex: 1,
  marginBottom: 50,

  '& a': {
    color: "$blue700",
  },

  '@lg': {
    marginBottom: 0,
  },
})